import type { MarketProgram } from '@/features/site/types/marketProgram'
import type { RevenuePeriod } from '@/features/site/types/revenue'

export function getMarketProgramsOptions(
  marketPrograms: MarketProgram[] | null,
  revenuePeriods: RevenuePeriod[] | null,
): MarketProgram[] {
  return (
    marketPrograms?.filter((marketProgram) =>
      revenuePeriods?.find((period) => period.serviceId === marketProgram.id),
    ) ?? []
  )
}
